"use client"

import { useEffect, useRef } from 'react'

const SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
let loading = null

const loadScript = () => {
    if (window.turnstile) return Promise.resolve(window.turnstile)
    if (!loading) loading = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = SCRIPT
        script.async = true
        script.onload = () => resolve(window.turnstile)
        script.onerror = reject
        document.head.appendChild(script)
    })
    return loading
}

// Wyzwanie Cloudflare Turnstile (tylko po przekroczeniu limitu); onToken — token do ponownego zapytania.
// Węższe miejsce niż 300 px — wersja kompaktowa; onRender — po wstawieniu widżetu.
export default function Turnstile ({ onRender, onToken, siteKey }) {
    const ref = useRef(null)
    const callback = useRef(onToken)
    callback.current = onToken

    useEffect(() => {
        let id = null
        loadScript().then(turnstile => {
            if (!ref.current || !turnstile) return
            id = turnstile.render(ref.current, { callback: token => callback.current(token), language: 'pl', sitekey: siteKey, size: ref.current.offsetWidth < 300 ? 'compact' : 'normal' })
            onRender?.(ref.current)
        }).catch(() => null)
        return () => { if (id !== null) window.turnstile?.remove(id) }
    }, [siteKey])

    return <div ref={ref} />
}
